function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.8 0H2.2C.99 0 0 .99 0 2.2v17.6C0 21.01.99 22 2.2 22h17.6c1.21 0 2.2-.99 2.2-2.2V2.2C22 .99 21.01 0 19.8 0zM6.6 18.7H3.3V8.8h3.3v9.9zM4.95 6.93c-1.1 0-1.98-.88-1.98-1.98s.88-1.98 1.98-1.98 1.98.88 1.98 1.98-.88 1.98-1.98 1.98zM18.7 18.7h-3.3v-5.83c0-.88-.77-1.65-1.65-1.65-.88 0-1.65.77-1.65 1.65v5.83H8.8V8.8h3.3v1.32c.55-.88 1.76-1.54 2.75-1.54 2.09 0 3.85 1.76 3.85 3.85v6.27z",
  fill: "#036FE2",
  fillRule: "nonzero"
});

var SvgLinkedinIcon = function SvgLinkedinIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedinIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedinIcon.1cac6c67.svg";
export { ForwardRef as ReactComponent };